import { get } from '@core/api/baseApi';
import { GetStudyResponse } from '@core/types';

const getStudy = async (studyInstanceUid?: string): Promise<GetStudyResponse> =>
  await get(`/studies/${studyInstanceUid}`);

export default getStudy;
